import Swiper from "swiper/bundle";
import { isMobile, isTablet } from "./../_helpers";
import EventsHelper from './../_helpers/events';

export const initBase = (el) => {
    return new Swiper(el, {
      speed: 600,
      slidesPerView: "auto",
      loop: false,
      autoplay: el.hasAttribute("js-carousel-autoplay")
        ? {
          delay: 4000,
        }
        : false,
      navigation: {
        nextEl: el.querySelector("[js-carousel-trigger-next]"),
        prevEl: el.querySelector("[js-carousel-trigger-prev]"),
      },
      pagination: {
        el: el.querySelector("[js-carousel-pagination]"),
        type: el.hasAttribute("js-carousel-fraction-pagination")
          ? "fraction"
          : "bullets",
      },
    });
  }

export const initMatches = (el) => {
    return new Swiper(el, {
      speed: 600,
      freeMode: true,
      slidesPerView: "auto",
      initialSlide: el.getAttribute("js-carouel-initialslide") || 0,
      //loopedSlides: null,
      loop: false,
      autoplay: el.hasAttribute("js-carousel-autoplay")
        ? {
          delay: 4000,
        }
        : false,
      navigation: {
        nextEl: el.querySelector("[js-carousel-trigger-next]"),
        prevEl: el.querySelector("[js-carousel-trigger-prev]"),
      },
      pagination: {
        el: el.querySelector("[js-carousel-pagination]"),
        type: el.hasAttribute("js-carousel-fraction-pagination")
          ? "fraction"
          : "bullets",
      },
    });
  }

export const initVbtvRails = (el) => {
    return new Swiper(el, {
      speed: 600,
      slidesPerView: "auto",
      spaceBetween: 0,
      slidesOffsetBefore: 10,
      slidesOffsetAfter: 10,
      observer: true,
      observeParents: true,
      loop: false,
      a11y: {
        slideRole: "link",
      },
      autoplay: el.hasAttribute("js-carousel-autoplay")
        ? {
          delay: 4000,
        }
        : false,
      navigation: {
        nextEl: isMobile() ? el.querySelector("[js-carousel-trigger-next]") : el.parentNode.parentNode.parentNode.querySelector("[video-rail-trigger-next]"),
        prevEl: isMobile() ? el.querySelector("[js-carousel-trigger-prev]") : el.parentNode.parentNode.parentNode.querySelector("[video-rail-trigger-prev]"),
      },
      pagination: {
        el: el.querySelector("[js-carousel-pagination]"),
        type: el.hasAttribute("js-carousel-fraction-pagination")
          ? "fraction"
          : "bullets",
        dynamicBullets: isMobile(),
        dynamicMainBullets: isMobile() ? 1 : 0,
      },
    });
  }

export const initMatchesCalendar = (el) => {
    return new Swiper(el, {
      speed: 600,
      slidesPerView: "auto",
      slidesOffsetAfter: 60,
      slidesOffsetBefore: 30,
      spaceBetween: 16,
      initialSlide: el.getAttribute("js-carouel-initialslide") || 0,
      loop: false,
      autoplay: el.hasAttribute("js-carousel-autoplay")
        ? {
          delay: 4000,
        }
        : false,
      navigation: {
        nextEl: el.querySelector("[js-carousel-trigger-next]"),
        prevEl: el.querySelector("[js-carousel-trigger-prev]"),
      },
      pagination: {
        el: el.querySelector("[js-carousel-pagination]"),
        type: el.hasAttribute("js-carousel-fraction-pagination")
          ? "fraction"
          : "bullets",
      },
    });
  }

export const initGallery = (el) => {
    return new Swiper(el, {
      speed: 600,
      slidesPerView: 1,
      loop: false,
      autoplay: el.hasAttribute("js-carousel-autoplay")
        ? {
          delay: 4000,
        }
        : false,
      navigation: {
        nextEl: el.querySelector("[js-carousel-trigger-next]"),
        prevEl: el.querySelector("[js-carousel-trigger-prev]"),
      },
      pagination: {
        el: el.querySelector("[js-carousel-pagination]"),
        type: el.hasAttribute("js-carousel-fraction-pagination")
          ? "fraction"
          : "bullets",
      },
    });
  }

export const initHero = (el) => {
    return new Swiper(el, {
      speed: 600,
      slidesPerView: "auto",
      loop: true,
      threshold: isMobile() || isTablet() ? 5 : 10,
      autoplay: el.hasAttribute("js-carousel-autoplay")
        ? {
          delay: 6000,
        }
        : false,
      navigation: {
        nextEl: el.querySelector("[js-carousel-trigger-next]"),
        prevEl: el.querySelector("[js-carousel-trigger-prev]"),
      },
      pagination: {
        el: el.querySelector("[js-carousel-pagination]"),
        type: el.hasAttribute("js-carousel-fraction-pagination")
          ? "fraction"
          : "bullets",
      },
    });

  }

export const initScheduleCalender = (el) => {
    const swiper = new Swiper(el, {
      speed: 600,
      centeredSlides: true,
      slidesPerView: isMobile() || isTablet() ? 3 : 5,
      spaceBetween: 20,
      observer: true,
      observeParents: true,
      initialSlide: el.getAttribute("js-carouel-initialslide") || 0,
      loop: false,
      autoplay: el.hasAttribute("js-carousel-autoplay")
        ? {
          delay: 4000,
        }
        : false,
      navigation: {
        nextEl: el.parentNode.querySelector("[js-gs-dates-next]"),
        prevEl: el.parentNode.querySelector("[js-gs-dates-prev]"),
      },
      pagination: {
        el: el.querySelector("[js-carousel-pagination]"),
        type: el.hasAttribute("js-carousel-fraction-pagination")
          ? "fraction"
          : "bullets",
      },
    });

    swiper.on("reachBeginning", function () {
      EventsHelper.Trigger("schedule-dates-end", { position: "start", swiper: swiper });
    });

    swiper.on("reachEnd", function () {
      EventsHelper.Trigger("schedule-dates-end", { position: "end", swiper: swiper });
    });

    swiper.on("slideChangeTransitionEnd", function () {
      EventsHelper.Trigger("schedule-date-change");
    })
    // click on the next arrow button
    swiper.on("slideNextTransitionStart", function (e) {
      EventsHelper.Trigger("schedule-date-change-by-arrow");
    })
    // click on the prev arrow button
    swiper.on("slidePrevTransitionStart", function (e) {
      EventsHelper.Trigger("schedule-date-change-by-arrow");
    })

    return swiper;
  }

export const initCompetitionNav = (el) => {
    const swiper = new Swiper(el, {
      speed: 600,
      slidesPerView: "auto",
      spaceBetween: 0,
      slidesOffsetAfter: window.innerWidth < 1024 ? 0 : 42,
      slidesOffsetBefore: window.innerWidth < 1024 ? 0 : 42,
      observer: true,
      observeParents: true,
      initialSlide: el.getAttribute("js-carouel-initialslide") || 0,
      loop: false,
      autoplay: el.hasAttribute("js-carousel-autoplay")
        ? {
          delay: 4000,
        }
        : false,
      navigation: {
        nextEl: el.parentNode.querySelector("[js-gs-dates-next]"),
        prevEl: el.parentNode.querySelector("[js-gs-dates-prev]"),
      },
      pagination: {
        el: el.querySelector("[js-carousel-pagination]"),
        type: el.hasAttribute("js-carousel-fraction-pagination")
          ? "fraction"
          : "bullets",
      },
    });

    return swiper;
  }

export const initPackagesNav = (el) => {
    const swiper = new Swiper(el, {
      speed: 600,
      slidesPerView: "auto",
      slidesOffsetBefore: 10,
      slidesOffsetAfter: 10,
      observer: true,
      observeParents: true,
      loop: false,
      autoplay: el.hasAttribute("js-carousel-autoplay")
        ? {
          delay: 4000,
        }
        : false,
      navigation: {
        nextEl: el.querySelector("[js-carousel-trigger-next]"),
        prevEl: el.querySelector("[js-carousel-trigger-prev]"),
      },
      pagination: {
        el: el.querySelector("[js-carousel-pagination]"),
        type: el.hasAttribute("js-carousel-fraction-pagination")
          ? "fraction"
          : "bullets",
        clickable: true,
      },
      slideToClickedSlide: true,
      observeSlideChildren: true
    });

    return swiper;
  }

export const initGsFilters = (el) => {
    const swiper = new Swiper(el, {
      speed: 600,
      slidesPerView: "auto",
      freeMode: true,
      observer: true,
      observeParents: true,
      spaceBetween: 4,
      loop: false,
      autoplay: el.hasAttribute("js-carousel-autoplay")
        ? {
          delay: 4000,
        }
        : false,
      navigation: {
        nextEl: el.parentNode.querySelector("[js-filters-prev]"),
        prevEl: el.parentNode.querySelector("[js-filters-next]"),
      },
      slideToClickedSlide: true,
      observeSlideChildren: true
    });
    return swiper;
  }
